import "../../styles/homePage/table/tablePage.scss";
import TableHeader, { TableHeaderParams } from "./TableHeader";
import { TableFiltersProps } from "./TableFilters";
import { CardsProps } from "./TableHeaderCards";
import { SortTableProps } from "./SortTable";
import {
  TablePageParams,
  TableProps,
  TableRowBase,
} from "../../types/Table.interface";
import Table from "./Table";
import { useRef, useEffect } from "react";

const TablePage = <T extends TableRowBase>({
  trashAction,
  totalCount,
  viewAllAction,
  filterAction,
  searchValue,
  setSearchValue,
  searchPlaceholder,
  buttonText,
  buttonAction,
  headerHeadline,
  tableHeadline,
  cards,
  setSortKey,
  sortKey,
  tableData,
  sortKeysArray,
  setSortOrder,
  sortOrder,
  onRowClick,
  onCheckBoxClick,
  className,
  isExport,
  exportAction,
  filtersText,
  createPath,
  isFetchingMore,
  hasMore,
  fetchMore,
  handleCheckAll,
  canEdit,
  canDelete,
  canToggleActive,
  onToggleActionClick,
  onDeleteClick,
  onEditClick,
  tabs,
  tableHeaderTitle,
  customContainerClass,
  extendGapInTable,
  versionAction,
  hideCheck,
  defaultActiveKey
}: TablePageParams &
  TableFiltersProps &
  TableHeaderParams &
  CardsProps &
  Partial<SortTableProps> &
  TableProps<T>) => {


  return (
    <div
      className={`table-page-main-container ${className ? className : ""}`}
    >
      <div className="table-header">
        <TableHeader
          headerHeadline={headerHeadline}
          cards={cards}
          totalCount={totalCount}
          viewAllAction={viewAllAction}
          tabs={tabs}
          tableHeaderTitle={tableHeaderTitle}
          customContainerClass={customContainerClass}

        />
      </div>
      <div className="table-content">
        <Table
          versionAction={versionAction}
          handleCheckAll={(e) => { handleCheckAll && handleCheckAll(e) }}
          createPath={createPath}
          setSortOrder={setSortOrder}
          sortOrder={sortOrder}
          tableHeadline={tableHeadline}
          trashAction={trashAction}
          filterAction={filterAction}
          onToggleActionClick={onToggleActionClick}
          onDeleteClick={onDeleteClick}
          onEditClick={onEditClick}
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          searchPlaceholder={searchPlaceholder}
          buttonText={buttonText}
          buttonAction={buttonAction}
          tableData={tableData}
          setSortKey={setSortKey}
          sortKey={sortKey}
          sortKeysArray={sortKeysArray}
          onRowClick={onRowClick}
          onCheckBoxClick={onCheckBoxClick}
          filtersText={filtersText}
          isExport={isExport}
          exportAction={exportAction}
          isFetchingMore={isFetchingMore}
          hasMore={hasMore}
          fetchMore={fetchMore}
          canEdit={canEdit}
          canDelete={canDelete}
          canToggleActive={canToggleActive}
          extendGapInTable={extendGapInTable}
          hideCheck={hideCheck}
        />
      </div>
    </div>
  );
};

export default TablePage;
